import * as Accordion from '@phoenix/components/Accordion';
import Masthead from '@maison/Masthead'; // TODO: Remove later once fixed on SG
import Stickyfill from 'stickyfilljs';

import {
  AnimateGroupReveal,
  AnimateReveal,
  BackgroundVideo,
  Collapse,
  datepickerField,
  Drawers,
  Field,
  Header,
  helpers,
  Marquee,
  Modal,
  Panel,
  Parallax,
  phoneField,
  PhxToaster,
  PromoBanner,
  Range,
  Ring,
  SearchPanel,
  SimpleSlider,
  slider,
  StickyAddToCart,
  stickyBar,
  ToggleTruncated,
  Tooltip,
  VideoPlayer,
} from '@phx-styleguides/pia';

import {
  addLoadingState as phxsgAddLoadingState,
  removeLoadingState as phxsgRemoveLoadingState,
} from '@sg/resources/assets/js/helpers/buttons';

const patchedHelpers = {
  ...helpers,
  buttons: {
    ...helpers.buttons,
    addLoadingState: phxsgAddLoadingState,
    removeLoadingState: phxsgRemoveLoadingState,
  },
};

export {
  Accordion,
  AnimateGroupReveal,
  AnimateReveal,
  BackgroundVideo,
  Collapse,
  datepickerField,
  Drawers,
  Field,
  Header,
  patchedHelpers as helpers,
  Marquee,
  Masthead,
  Modal,
  Panel,
  Parallax,
  phoneField,
  PhxToaster,
  PromoBanner,
  Range,
  Ring,
  SearchPanel,
  SimpleSlider,
  slider,
  StickyAddToCart,
  stickyBar,
  Stickyfill,
  ToggleTruncated,
  Tooltip,
  VideoPlayer,
};
